import TestRigPageContainer from './test-rig/TestRigPageContainer';

export default TestRigPageContainer;
